import { Dispatch } from 'redux';
import { ReduxComponentInterface } from 'edocatbase/Global';
import { PathPickerType } from '../types/enums';
import '../../../Styles/PathPicker.scss';
import DisplayList from './DisplayList';
import Modal from './Modal/Modal';
import Button from '../../Button';
import { path } from 'ramda';
import { getObjectFromArray } from "../utils/arrToObj";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { toggleModal } from '../../ModalTest/actions';

interface PathPickerProps extends ReduxComponentInterface {
  type: PathPickerType;
  selected?: string[];
  hidden?: string[];
  showFileList?: boolean;
  multiSelect?: boolean;
  isMandatory?: boolean;
  disabled?: boolean;
  onSubmit: Function;
  onItemDelete?: Function;
  name: string;
  modal?: any;
  formInstanceId?: string;
  reducerPath?: string[];
  id?: string;
  site?: string;
  title?: string;
  initialText?: string;
  pckg_mode?: string | null | undefined;
  bpm_context?: string;
  pckg_upload?: boolean;
  uploadButton?: any;
  deleteWFpackageItemsModal?: boolean;
	changeOrder?: Function;
}

class PathPicker extends window.React.PureComponent<PathPickerProps> {

  render() {
    const {
      hidden,
      onSubmit,
      type,
      showFileList,
      reducerPath,
      selected,
      modal,
      actions,
      formInstanceId,
      onItemDelete,
      multiSelect,
      name,
      isMandatory,
      id,
      disabled,
      site,
      pckg_mode,
      title,
      bpm_context,
      initialText,
      pckg_upload,
      uploadButton,
			changeOrder,
      taskForm,
			workflowForm
    } = this.props;

    /** Modals final reducer name, based on ID (if there!s no ID, NAME is used instead) **/
    const modalReducer = id ?? name;

    return (
      <div className="PathPicker">
        {showFileList && (
          <window.React.Fragment>
            <DisplayList
              selected={selected || []}
              onDeleteBtnClick={onItemDelete}
              isMandatory={!!isMandatory}
              disabled={disabled}
              hidden={hidden}
              pckg_mode={pckg_mode}
              bpm_context={bpm_context}
							changeOrder={changeOrder}
            />
            <div className='buttonsDiv'>
              {((uploadButton && uploadButton != "") || (!disabled && (pckg_upload !== undefined ? pckg_upload && pckg_mode : true))) && (taskForm || workflowForm) && (
                  <p style={{ marginRight: "10px" }}>
                    {window.Alfresco.messages.global['edocat.workflowScreen.packageItems.label']}
                  </p>
              )}
              {!disabled && (pckg_upload !== undefined ? pckg_upload && pckg_mode : true) && (
                <Button
                  id={id}
                  onClick={() => actions.toggleModal(true, modalReducer, reducerPath, formInstanceId)}
                  label={window.Alfresco.messages.global['button.select']}
                />
              )}
              {uploadButton && uploadButton != "" && uploadButton}
            </div>
          </window.React.Fragment>
        )}
        {/* @ts-ignore */}
        {(reducerPath ? path([...reducerPath, modalReducer], this.props)?.isOpen : modal?.[modalReducer]?.isOpen) && (
          <Modal
            type={type}
            reducerPath={reducerPath}
            selected={getObjectFromArray(selected || [])}
            formInstanceId={formInstanceId}
            multiSelect={multiSelect}
            onSubmit={onSubmit}
            hidden={getObjectFromArray(hidden || [])}
            name={modalReducer}
            site={site}
            title={title}
            initialText={initialText}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  ...state,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: bindActionCreators({ toggleModal }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(PathPicker);
